export function supportsCSSVariables(): boolean {
  return window.CSS && CSS.supports('color', 'var(--color-var)')
}
